import { get, post, put, publicGet } from './_httpClient';

export async function getOptionsUniversities({
  q = '',
  typeId = '',
  page,
  pageSize,
}) {
  const { status, message, data } = await publicGet(
    `/universities-options?q=${q}&typeId=${typeId}&page=${page}&pageSize=${pageSize}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getUniversities({ q = '', page, pageSize }) {
  // SENGAJA pakai `get` (mengirim token), bukan `publicGet`. Endpoint ini
  // (`GET /universities`) auth-nya `{ mode: 'try' }` -- boleh diakses tanpa
  // token, TAPI kalau tanpa token, back-end meredaksi partnershipState/
  // partnershipActiveUntil supaya postur kemitraan tidak bocor ke publik
  // (lihat universities/handler.js, back-end). Halaman ini
  // (/admin/universities) khusus admin yang sudah login -- pakai
  // `publicGet` di sini justru MENYEMBUNYIKAN status kerja sama dari
  // admin sendiri, persis bug yang membuat semua baris tampil "Belum Ada
  // Kerja Sama" walau detailnya benar (yang memang authenticated).
  const { status, message, data } = await get(
    `/universities?q=${q}&page=${page}&pageSize=${pageSize}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getUniversityDetail({ id }) {
  const { status, message, data } = await get(`/universities/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function addUniversities({ payload }) {
  const { status, message } = await post('/universities', payload);
  if (status !== 'success') {
    throw new Error(message);
  }
}

export async function updateUniversities({ payload, id }) {
  const responseJson = await put(`/universities/${id}`, payload);
  const { status, message } = responseJson;
  if (status !== 'success') {
    throw new Error(message);
  }
  return responseJson;
}

export async function getMajorsByUniversity({ id }) {
  const { status, message, data } = await publicGet(`/universities/${id}/major`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function addMajor({ payload }) {
  const responseJson = await post('/universities/major', payload);
  const { status, message } = responseJson;
  if (status !== 'success') {
    throw new Error(message);
  }
  return responseJson;
}

export async function requestAddPendingUniversityRegistration({
  name,
  majorId,
  typeId,
}) {
  const { status, message, data } = await post('/universities/registrations', {
    name,
    majorId,
    typeId,
    status: 'PENDING',
  });
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getMajors({ q = '', typeId = '', page, pageSize }) {
  const { status, message, data } = await get(
    `/universities/major?q=${q}&typeId=${typeId}&page=${page}&pageSize=${pageSize}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data.result || [];
}
